var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "dialog-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onCancel.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "dialog",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.titleId,
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("header", { staticClass: "dialog-header" }, [
            _c(
              "h2",
              { staticClass: "dialog-title", attrs: { id: _vm.titleId } },
              [_vm._v(_vm._s(_vm.$t("myPage.userInfo.edit.title")))]
            ),
            _c(
              "button",
              {
                staticClass: "close-button",
                attrs: {
                  type: "button",
                  "aria-label": _vm.$t("myPage.userInfo.edit.closeAriaLabel"),
                },
                on: { click: _vm.onCancel },
              },
              [_c("icon-close", { staticClass: "close-icon" })],
              1
            ),
          ]),
          _c("div", { staticClass: "dialog-body" }, [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-header" }, [
                _c(
                  "label",
                  {
                    staticClass: "field-label",
                    attrs: { for: "user-info-name" },
                  },
                  [_vm._v(_vm._s(_vm.$t("myPage.userInfo.name")))]
                ),
                _c("span", { staticClass: "field-count" }, [
                  _vm._v(_vm._s(_vm.name.length) + "/100"),
                ]),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name",
                  },
                ],
                staticClass: "field-input",
                class: { error: !!_vm.errors.name },
                attrs: {
                  id: "user-info-name",
                  type: "text",
                  maxlength: "100",
                  placeholder: _vm.$t("myPage.userInfo.edit.namePlaceholder"),
                },
                domProps: { value: _vm.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.name = $event.target.value
                  },
                },
              }),
              _vm.errors.name
                ? _c("p", { staticClass: "field-error" }, [
                    _vm._v(_vm._s(_vm.errors.name)),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-header" }, [
                _c(
                  "label",
                  {
                    staticClass: "field-label",
                    attrs: { for: "user-info-name-kana" },
                  },
                  [_vm._v(_vm._s(_vm.$t("myPage.userInfo.nameKana")))]
                ),
                _c("span", { staticClass: "field-count" }, [
                  _vm._v(_vm._s(_vm.nameKana.length) + "/100"),
                ]),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.nameKana,
                    expression: "nameKana",
                  },
                ],
                staticClass: "field-input",
                class: { error: !!_vm.errors.nameKana },
                attrs: {
                  id: "user-info-name-kana",
                  type: "text",
                  maxlength: "100",
                  placeholder: _vm.$t(
                    "myPage.userInfo.edit.nameKanaPlaceholder"
                  ),
                },
                domProps: { value: _vm.nameKana },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.nameKana = $event.target.value
                  },
                },
              }),
              _vm.errors.nameKana
                ? _c("p", { staticClass: "field-error" }, [
                    _vm._v(_vm._s(_vm.errors.nameKana)),
                  ])
                : _vm._e(),
            ]),
            _c(
              "div",
              { staticClass: "penname-section" },
              [
                _c("p", { staticClass: "penname-title" }, [
                  _vm._v(_vm._s(_vm.$t("myPage.userInfo.penname"))),
                ]),
                _c("p", { staticClass: "penname-description" }, [
                  _vm._v(
                    _vm._s(_vm.$t("myPage.userInfo.edit.pennameDescription"))
                  ),
                ]),
                _c(
                  "ul",
                  { staticClass: "penname-list" },
                  _vm._l(_vm.pennames, function (penname, index) {
                    return _c(
                      "li",
                      {
                        key: `${penname}-${index}`,
                        staticClass: "penname-chip",
                        class: { dragging: _vm.draggingIndex === index },
                        attrs: { draggable: "true" },
                        on: {
                          dragstart: function ($event) {
                            return _vm.onDragStart(index)
                          },
                          dragover: function ($event) {
                            $event.preventDefault()
                            return _vm.onDragOver(index)
                          },
                          dragend: _vm.onDragEnd,
                        },
                      },
                      [
                        _c("icon-handle", { staticClass: "penname-handle" }),
                        index === 0
                          ? _c("icon-star", { staticClass: "penname-star" })
                          : _vm._e(),
                        _c("span", { staticClass: "penname-text" }, [
                          _vm._v(_vm._s(penname)),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass: "penname-remove",
                            attrs: {
                              type: "button",
                              "aria-label": _vm.$t("common.delete"),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onRemovePenname(index)
                              },
                            },
                          },
                          [
                            _c("icon-close", {
                              staticClass: "penname-remove-icon",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm.errors.penname
                  ? _c("p", { staticClass: "field-error" }, [
                      _vm._v(_vm._s(_vm.errors.penname)),
                    ])
                  : _vm._e(),
                _vm.isAddingPenname
                  ? [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "field-header" }, [
                          _c(
                            "label",
                            {
                              staticClass: "field-label",
                              attrs: { for: "user-info-new-penname" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("myPage.userInfo.edit.newPenname")
                                )
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "field-count" }, [
                            _vm._v(_vm._s(_vm.newPenname.length) + "/50"),
                          ]),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newPenname,
                              expression: "newPenname",
                            },
                          ],
                          ref: "newPennameInput",
                          staticClass: "field-input",
                          attrs: {
                            id: "user-info-new-penname",
                            type: "text",
                            maxlength: "50",
                            placeholder: _vm.$t(
                              "myPage.userInfo.edit.newPennamePlaceholder"
                            ),
                          },
                          domProps: { value: _vm.newPenname },
                          on: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              $event.preventDefault()
                              return _vm.onRegisterPenname.apply(
                                null,
                                arguments
                              )
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.newPenname = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "penname-add-actions" }, [
                        _c(
                          "button",
                          {
                            staticClass: "penname-action-button",
                            attrs: { type: "button" },
                            on: { click: _vm.onCancelAddPenname },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "penname-action-button primary",
                            attrs: {
                              type: "button",
                              disabled: !_vm.canRegisterPenname,
                            },
                            on: { click: _vm.onRegisterPenname },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("myPage.userInfo.edit.register")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  : _c(
                      "button",
                      {
                        staticClass: "add-penname-button",
                        attrs: {
                          type: "button",
                          disabled: _vm.isPennameListFull,
                        },
                        on: { click: _vm.onStartAddPenname },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("myPage.userInfo.edit.addPenname")) +
                            " "
                        ),
                      ]
                    ),
              ],
              2
            ),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-header" }, [
                _c(
                  "label",
                  {
                    staticClass: "field-label",
                    attrs: { for: "user-info-phone" },
                  },
                  [_vm._v(_vm._s(_vm.$t("myPage.userInfo.phone")))]
                ),
                _c("span", { staticClass: "field-count" }, [
                  _vm._v(_vm._s(_vm.phone.length) + "/100"),
                ]),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.phone,
                    expression: "phone",
                  },
                ],
                staticClass: "field-input",
                class: { error: !!_vm.errors.phone },
                attrs: {
                  id: "user-info-phone",
                  type: "tel",
                  maxlength: "100",
                  placeholder: _vm.$t("myPage.userInfo.edit.phonePlaceholder"),
                },
                domProps: { value: _vm.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.phone = $event.target.value
                  },
                },
              }),
              _vm.errors.phone
                ? _c("p", { staticClass: "field-error" }, [
                    _vm._v(_vm._s(_vm.errors.phone)),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "field" }, [
              _c(
                "label",
                {
                  staticClass: "field-label",
                  attrs: { for: "user-info-gender" },
                },
                [_vm._v(_vm._s(_vm.$t("myPage.userInfo.gender")))]
              ),
              _c(
                "div",
                { staticClass: "select-wrapper" },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.gender,
                          expression: "gender",
                        },
                      ],
                      staticClass: "field-input field-select",
                      attrs: { id: "user-info-gender" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.gender = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(_vm._s(_vm.$t("common.unselected"))),
                      ]),
                      _vm._l(_vm.genderOptions, function (option) {
                        return _c(
                          "option",
                          {
                            key: option.value,
                            domProps: { value: option.value },
                          },
                          [_vm._v(" " + _vm._s(option.label) + " ")]
                        )
                      }),
                    ],
                    2
                  ),
                  _c("icon-chevron-down", { staticClass: "select-chevron" }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c(
                "label",
                {
                  staticClass: "field-label",
                  attrs: { for: "user-info-birthdate" },
                },
                [_vm._v(_vm._s(_vm.$t("myPage.userInfo.birthdate")))]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.birthdate,
                    expression: "birthdate",
                  },
                ],
                staticClass: "field-input",
                class: { error: !!_vm.errors.birthdate },
                attrs: { type: "date", id: "user-info-birthdate" },
                domProps: { value: _vm.birthdate },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.birthdate = $event.target.value
                  },
                },
              }),
              _vm.errors.birthdate
                ? _c("p", { staticClass: "field-error" }, [
                    _vm._v(_vm._s(_vm.errors.birthdate)),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("footer", { staticClass: "dialog-footer" }, [
            _c(
              "button",
              {
                staticClass: "footer-button primary",
                attrs: { type: "button", disabled: _vm.saving },
                on: { click: _vm.onSubmit },
              },
              [_vm._v(" " + _vm._s(_vm.$t("myPage.userInfo.update")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "footer-button",
                attrs: { type: "button", disabled: _vm.saving },
                on: { click: _vm.onCancel },
              },
              [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }